import boardLaneBuilder from './BoardLaneBuilder';
import { BOARD_STATE_ACTIVE, BOARD_STATE_COMPLETED, DEFAULT_STAGE, DONE_STAGE } from './boardConst';

// Pure: fields an item needs so it lands in the lane it was dropped on
class BoardDropResolver {
    /**
     * @param {object} item - board item
     * @param {object} lane - lane config the item was dropped on
     * @param {object[]} lanes - all lanes of the board
     * @returns {object} fields to write
     */
    resolve = (item, lane, lanes) => {
        const rule = this._targetRule(lane);
        const fields = this._ruleFields(rule);
        fields.stage = this._stage(lane, rule, item);
        this._reopen(item, lane, fields);
        this._forceType(item, lane, lanes, fields);
        return fields;
    };

    // Stage lanes: first rule, view lanes: last rule
    _targetRule = (lane) => {
        const rules = lane.match ?? [];
        if (!rules.length) return {};
        if (lane.dropStage) return rules[0];
        return rules[rules.length - 1];
    };

    _ruleFields = (rule) => {
        const fields = {};
        if (rule.type?.length) fields.type = rule.type[0];
        if (rule.cat?.length) fields.cat = rule.cat[0];
        return fields;
    };

    _stage = (lane, rule, item) => {
        if (lane.dropStage) return lane.dropStage;
        if (rule.stage?.length) return rule.stage[0];
        if (item.stage === DONE_STAGE) return DEFAULT_STAGE;
        return item.stage;
    };

    // Completed always lands in Done — reopen when dropped elsewhere
    _reopen = (item, lane, fields) => {
        if (item.stateId !== BOARD_STATE_COMPLETED) return;
        if (lane.dropStage === DONE_STAGE) return;
        fields.stateId = BOARD_STATE_ACTIVE;
    };

    // Issue still caught by an earlier stage lane → becomes a Note
    _forceType = (item, lane, lanes, fields) => {
        if (fields.type) return;
        const moved = { ...item, ...fields };
        if (boardLaneBuilder.laneOf(moved, lanes) === lane.id) return;
        fields.type = 'Note';
    };
}

const boardDropResolver = new BoardDropResolver();
export default boardDropResolver;
